export const SET_BUSINESS = 'SET_BUSINESS';
export const SET_EMPLOYEES = 'SET_EMPLOYEES';
export const SELECT_EMPLOYEE = 'SELECT_EMPLOYEE';
export const SET_CURRENT_CARD = 'SET_CURRENT_CARD';
export const SET_CARD_LOADING = 'SET_CARD_LOADING';
